import { useLayoutEffect } from 'react';
import throttle from 'lodash/throttle';

// We need this hook to update the slider position when the component is loaded,
// otherwise the slider will be positioned incorrectly
// the throttle function is used to prevent the slider from being updated too often,
// but we need to run it only once, so we can ignore the typescript warning
export const useWindowResize = (handleResize: () => void) => {
    useLayoutEffect(() => {
        const throttledResizeFunc = throttle(handleResize, 500);

        window.addEventListener('resize', throttledResizeFunc);
        throttledResizeFunc();

        return () => {
            window.removeEventListener('resize', throttledResizeFunc);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
